import { omit } from 'lodash-es'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { TextField, ITextFieldProps } from '../text-field'
import textFieldShape from '../text-field/text-field-shape'
import { IInputProps } from '../../types'
import { ICompletionListWrapperProps, CompletionListWrapper } from '../completion-list'

interface IAutoCompleteProps {
  border?: boolean
  flush?: boolean
}

export class AutoComplete extends React.Component<
  IAutoCompleteProps &
    Omit<ICompletionListWrapperProps, 'children'> &
    ITextFieldProps & { input?: IInputProps<React.ChangeEvent<HTMLInputElement>> } & IInputProps<
      React.ChangeEvent<HTMLInputElement>
    >
> {
  static propTypes = {
    ...textFieldShape,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.object]).isRequired,
    filterFunction: PropTypes.func,
    onCreate: PropTypes.func,
    onComplete: PropTypes.func.isRequired,
    highlightOptions: PropTypes.bool,
    disableFiltering: PropTypes.bool,
    border: PropTypes.bool,
    flush: PropTypes.bool,
  }

  static defaultProps = {
    border: true,
    highlightOptions: false,
    disableFiltering: false,
  }

  static VARIANTS = ['normal', 'success']

  render() {
    const {
      readOnly,
      options,
      value,
      highlightOptions,
      onComplete,
      onChange,
      onCreate,
      style,
      ...additionalProps
    } = this.props

    return (
      <CompletionListWrapper
        highlightOptions={highlightOptions}
        onChange={onChange}
        onComplete={onComplete}
        onCreate={onCreate}
        options={options}
        readOnly={readOnly}
        style={{ ...(additionalProps.flush ? { marginBottom: 0 } : {}) }}
        value={value}
      >
        {({ ...props }) => (
          <TextField
            style={{
              ...style,
              ...(!additionalProps.border ? { border: 'none' } : {}),
            }}
            type="text"
            {...props}
            {...omit(additionalProps, ['filterFunction', 'disableFiltering', 'border', 'flush'])}
            autoComplete="off"
            onBlur={e => {
              props?.onBlur(e)
              if (additionalProps?.onBlur) {
                additionalProps.onBlur(e)
              }
            }}
            onFocus={e => {
              props?.onFocus(e)
              if (additionalProps?.onFocus) {
                additionalProps.onFocus(e)
              }
            }}
          />
        )}
      </CompletionListWrapper>
    )
  }
}
